import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type ActionButtonProps = {
  onClick: () => void;
  icon: IconDefinition;
  text: string;
  color: string;
};

export function ActionButton({ onClick, icon, text, color }: ActionButtonProps) {
  return (
    <button type="button" className="transparent-button profile-btn" onClick={onClick}>
      <FontAwesomeIcon icon={icon} className="smaller-icon" style={{ color }} />
      <div className="slider-text">{text}</div>
    </button>
  );
}
